// filebase.ts basic file handling class
// it is the base to create file system for access any online drive
// which need to extent this base class
// it model the FileSystem in javascript
// import { delay, fileExtToContentType } from './appFuncs';

import { EntryMetadata, ExtendedField, FileSystemOptions, FileSystemConfig, PureMetadata } from './filebase'
import * as fb from './filebase'
import * as largeFileUpload from './filebaseSharepointLargeFileUpload'

export interface SPFileSystemConfig extends FileSystemConfig {
    clientDomain?: string,
    urlOverwrite: string
}
export class BaseEntry extends fb.BaseEntry {
    fileSystem: FileSystem;

    static extentedFieldSpec?: Array<string> = ["id", "name", "url", "size", "version"]; // provide what extra fields file system can support
    constructor(name: string, fileSystem: FileSystem) {
        super();
        this.name = name;
        this.fileSystem = fileSystem;
    }
    // request should be use in class functions so it is easy to change instead of direcly use base call
    async httpCall(url: string, method: string = "GET", postData?: string | Blob | ArrayBuffer, options?: any): Promise<any> {
        //var token = await this.fileSystem.getAccessToken();
        var contentType = "application/json";
        //if (typeof postData === 'object')
        //    contentType = undefined;  // do not send
        var retType = options && options.xhrFields && options.xhrFields.responseType ? options.xhrFields.responseType : '';
        let xhr;

        if (method === "PUT") {
            let newUrl = `${this.fileSystem.config.urlOverwrite}&lddurl=${encodeURIComponent(url)}&lddsetting=${JSON.stringify(options)}`;
            newUrl = newUrl.replace("sendToSharepoint", "uploadBlob");
            xhr = await fetch(newUrl, {
                method: "PUT",
                mode: 'cors',
                headers: {
                    "Content-Type": contentType,
                },
                body: postData
            });
        }
        if (retType === "blob") {
            let newUrl = `${this.fileSystem.config.urlOverwrite}&lddurl=${encodeURIComponent(url)}`;
            newUrl = newUrl.replace("sendToSharepoint", "getBlob")
            xhr = await fetch(newUrl, {
                method: "GET",
                mode: 'cors',
                headers: {
                    "Content-Type": contentType,
                }
            });
        } else {

            let midPackage = {
                type: contentType,
                rootDrive: this.fileSystem.config.rootDrive,
                url: url,
                method: method,
                postData: postData,
                options: options
            }

            xhr = await fetch(this.fileSystem.config.urlOverwrite, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                //                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                //                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    "Content-Type": contentType,
                },
                //         redirect: 'follow', // manual, *follow, error
                //         referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(midPackage)
            });

        }

        if (xhr.status >= 200 && xhr.status <= 299) {
            switch (retType) {
                case 'blob':
                    return xhr.blob();
                case 'arraybuffer':
                    return xhr.arrayBuffer();
                default:
                    var ret = await xhr.json();
                    if (ret.error > "") {
                        throw ret.error;
                    }
                    return ret;
                /*
                    const contentType = xhr.headers.get("content-type");
                    if (contentType.indexOf("text/xml") !== -1  && options.converters['text xml'] ) {
                        return options.converters['text xml'](await xhr.text());
                    } else if (contentType.indexOf("application/json") !== -1)
                        return xhr.json();
                    else // default return text
                        return xhr.text();*/
            }
        } else {
            throw (`request failed ${xhr.statusText}`);
        }
    }
    /*
     will not overwrite
     both parameters are optional, but you need at least one, otherwise there is nothing to do
    */
    async getGraphUrlByID(): Promise<string> {
        var id = this.id
        if (!(id > "")) {
            var meta = await this.getMetadata();
            id = meta.u_id;
        }
        var url = `${this.fileSystem.config.host}/items/${id}`;
        return url
    }

    async copyTo(newParent?: FolderEntry, newName?: string): Promise<FolderEntry | FileEntry> {
        var newFile: FolderEntry | FileEntry = null;
        try {

            var url = await this.getGraphUrlByID() + `/copy`;
            var myPost = {};
            var newLocation: FolderEntry = null;
            if (newParent) {
                var metaParent = await newParent.getMetadata();
                newLocation = newParent;
                myPost["parentReference"] = {
                    "id": metaParent.u_id
                }
            } else {
                newLocation = await this.getParent();
            }

            if (newName > "") myPost["name"] = newName;
            else newName = this.name;
            await this.httpCall(url, "POST", JSON.stringify(myPost));
            if (this.isFile)
                newFile = await newLocation.getFile(newName);
            else
                newFile = await newLocation.getFolder(newName);
        } catch (e) {
            if (e === "request failed Locked") {
                throw "This document is locked and could not be copied. Please try again later.";
            } else if (e === "request failed Conflict") {
                throw "conflict";
            }
            throw `Failed to copy file ${this.name}: ${e}`;
        }
        return newFile;
    }

    /*
     will not overwrite
     both parameters are optional, but you need at least one, otherwise there is nothing to do
    */
    async moveTo(newParent: FolderEntry, newName?: string): Promise<FolderEntry | FileEntry> {
        var newFile: FolderEntry | FileEntry = null;
        try {
            var myPost = {};
            var metaParent = await newParent.getMetadata();
            myPost["parentReference"] = {
                "id": metaParent.u_id
            }

            if (newName > "") myPost["name"] = newName;
            else newName = this.name;

            await this.httpCall(this.buildFullPath(), "PATCH", JSON.stringify(myPost));
            if (this.isFile)
                newFile = await newParent.getFile(newName);
            else
                newFile = await newParent.getFolder(newName);
        } catch (e) {
            if (e === "request failed Locked") {
                throw "This document is locked and could not be renamed/moved. Please try again later.";
            } else if (e === "request failed Conflict") {
                throw "conflict";
            }
            throw `Failed to move file ${this.name}: ${e}`;
        }
        return newFile;
    }


    // need to program the move to recycle bin instead of just delete
    async remove(): Promise<boolean> {
        var ret = true;
        try {
            await this.httpCall(this.buildFullPath(), "DELETE");
        } catch (e) {
            if (e === "request failed Locked") {
                throw "This document is locked and could not be removed. Please try again later.";
            }
            throw `Failed to remove file ${this.name}: ${e}`;
        }
        return ret;
    }

    async getParent(): Promise<FolderEntry> {
        var root: FolderEntry = this.fileSystem.root;
        var myFolder: FolderEntry = null;
        var path: string = this.fullPath;
        if (!(path === null || path === "")) {
            if (this.fullPath === root.name) myFolder = root;
            else {
                path = path.substring(root.name.length + 1);
                myFolder = await root.getFolder(path);
            }
        }
        return myFolder;
    }

    // just in case standarded fields cannot get it when GetFile
    async getMetadata(selectFields?: [string]): Promise<EntryMetadata> {
        var ret: EntryMetadata = {};
        try {
            var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
            if (selectFields == null) {
                ret.u_id = data.id;
                ret.created = data.createdDateTime;
                if (data.createdBy && data.createdBy.user)
                    ret.createdBy = data.createdBy.user.email;
                ret.lastModified = data.lastModifiedDateTime;
                if (data.lastModifiedBy && data.lastModifiedBy.user)
                    ret.lastModifiedBy = data.lastModifiedBy.user.email;
            } else {
                for (var i = 0; i < selectFields.length; i++) {
                    switch (selectFields[i].toLowerCase()) {
                        case "created":
                            ret.created = data.createdDateTime;
                            break;
                        case "createdby":
                            if (data.createdBy && data.createdBy.user)
                                ret.createdBy = data.createdBy.user.email;
                            break;
                        case "lastmodified":
                            ret.lastModified = data.lastModifiedDateTime;
                            break;
                        case "id":
                            ret.u_id = data.id;
                            break;
                        case "lastmodifiedby":
                            if (data.lastModifiedBy && data.lastModifiedBy.user)
                                ret.lastModifiedBy = data.lastModifiedBy.user.email;
                            break;
                    }
                }
            }
        } catch (e) {
            throw `Can not access information for "${this.name}": ${e}`;
        }
        return ret;
    }
    getTags(): Promise<Array<string>> {
        return null;
    }
    addTags(tags: string | Array<string>): Promise<void> {
        return null;
    }
    // remove all if no tags param
    removeTags(tags?: string | Array<string>): Promise<void> {
        return null;
    }
    // no name param  get all
    async getPureMeta(): Promise<PureMetadata> {
        var ret: PureMetadata = {};
        var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
        ret.id = data.id ? data.id : null;
        ret.name = data.name ? data.name : null;
        ret.size = data.size ? data.size : null;
        ret.webUrl = data.webUrl ? data.webUrl : null;
        ret.contentType = data.file && data.file.mimeType ? data.file.mimeType : null;
        ret.contentUrl = data["@microsoft.graph.downloadUrl"] ? data["@microsoft.graph.downloadUrl"] : null;
        return ret;
    }
    async getExtendedFields(names?: string | Array<string>): Promise<ExtendedField | Array<ExtendedField>> {
        var ret: Array<ExtendedField> = [];
        var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
        if (typeof (names) == "string") {
            let tmp: ExtendedField = {
                "name": names,
                "value": data[names]
            }
            return tmp;
        } else
            for (var i = 0; i < BaseEntry.extentedFieldSpec.length; i++) {
                let field = BaseEntry.extentedFieldSpec[i];
                switch (field) {
                    case "id":
                    case "name":
                    case "size":
                        ret.push({ name: field, value: data[field] } as any);
                        break;
                    case "url":
                        ret.push({ name: field, value: data.webUrl } as any);
                        break;
                }
            }
        return ret;
    }
    updateExtendedFields(fld: ExtendedField | Array<ExtendedField>): Promise<void> {
        return null;
    }

    async getDownloadUrl(): Promise<string> {
        var myUrl = null;
        try {
            // var path = this.buildFullPath() + "?comp=metadata";
            // path = path;
            var id = await this.getGraphUrlByID();
            var data = await this.httpCall(id + "?comp=metadata");
            myUrl = data.webUrl;
        } catch (e) {
            throw "Can't retieve file information " + e;
        }
        return myUrl;
    }
    async getShareableUrl(who?: string, expire?: Date): Promise<string> {
        var myUrl = null;
        try {
            var myPost = {
                "type": "edit",
                "scope": "anonymous"
            }
            var data = await this.httpCall(this.buildFullPath() + ":/createLink", "POST", JSON.stringify(myPost));
            myUrl = data.link.webUrl;
        } catch (e) {
            throw "Can't create share link " + e;
        }
        return encodeURI(myUrl);
    }

    buildSubPath(): string {
        var currentPath = "";
        if (this.fullPath > "")
            currentPath = this.fullPath + "/";
        currentPath += this.name;
        return currentPath;
    }

    buildFullPath(): string {
        var url = `${this.fileSystem.config.host}/root:/${this.buildSubPath()}`;
        return url;
    }
}

export class FileEntry extends BaseEntry implements fb.FileEntry {
    isFile: boolean = true;
    isDirectory: boolean = false;


    private async callContent(url: string, type: 'blob' | 'arrayBuffer' | string | 'xml' = ""): Promise<Blob | ArrayBuffer | string> {
        var myContent = null;
        try {
            var settings: any = {};
            settings['crossDomain'] = true;
            switch (type.toLowerCase()) {
                case "blob":
                    settings.xhrFields = {
                        responseType: 'blob'
                    }
                    /*settings.xhr = function () {// Seems like the only way to get access to the xhr object
                        var xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob';
                        return xhr;
                    };*/
                    myContent = await this.httpCall(url, "GET", null, settings);

                    break;
                case "arraybuffer":
                    settings.xhrFields = {
                        responseType: 'arraybuffer'
                    }
                    /*settings.xhr = function () {// Seems like the only way to get access to the xhr object
                        var xhr = new XMLHttpRequest();
                        xhr.responseType = 'arraybuffer';
                        return xhr;
                    };*/
                    myContent = await this.httpCall(url, "GET", null, settings);
                    break;

                case "xml":
                    settings.converters = {
                        'text xml': function (data) {
                            /* tomas to fix
                            var tmp = lddCreateXMLDocument();
                            tmp.loadXML(data)*/
                            return data;
                        }
                    };
                    myContent = await this.httpCall(url, "GET", null, settings);
                    break;
                default:
                    var tmp = await this.httpCall(url, "GET", null, settings);
                    myContent = tmp;
            }
        } catch (e) {
            throw "Can't retieve file information " + e;
        }
        return myContent;
    }

    async getContent(type: 'blob' | 'arrayBuffer' | string | 'xml', convertToFormat: string = ""): Promise<Blob | ArrayBuffer | string | XMLDocument> {
        var meta: any = await this.getExtendedFields("@microsoft.graph.downloadUrl");
        var url: string = await this.getGraphUrlByID() + `/content`;
        var useDLlink = true;
        if (convertToFormat > "") {
            switch (convertToFormat.toLowerCase()) {
                case "pdf":
                    if (this.ext !== "pdf") {
                        url += "?format=pdf";
                        useDLlink = false;
                    }
            }
        }
        if (meta.value > "" && useDLlink) {
            url = meta.value;
        };
        return await this.callContent(url, type);
    }

    async downloadFile(): Promise<void> {
        var meta: any = await this.getExtendedFields("@microsoft.graph.downloadUrl");
        var url: string = await this.getGraphUrlByID() + `/content`;
        if (meta.value > "") {
            url = meta.value;
        };

        window.open(url);
    }

    async getHistories?(): Promise<Array<EntryMetadata>> {
        var histories = []
        try {
            var data = await this.httpCall(this.buildFullPath() + ":/versions");
            for (var i = 1; i < data.value.length; i++) {
                var tmp = data.value[i];
                var prev = data.value[i - 1];
                if (prev == null || !(prev.size === tmp.size)) {
                    var entry: EntryMetadata = {}
                    entry.version = tmp.id;
                    entry.lastModified = tmp.lastModifiedDateTime;
                    if (tmp.lastModifiedBy && tmp.lastModifiedBy.user)
                        entry.lastModifiedBy = tmp.lastModifiedBy.user.email;
                    histories.push(entry);
                }
            }
        } catch (e) {
            throw "Can't retieve file information " + e;
        }
        return histories;
    }

    async getHistoryContent?(version: string, type?: 'blob' | 'arrayBuffer' | 'xml' | string): Promise<Blob | ArrayBuffer | string> {
        var url = await this.getGraphUrlByID() + `/versions/${version}/content`;
        return await this.callContent(url, type);
    }

    async revertToHistory?(version: string): Promise<boolean> {
        var ret = true;
        try {
            var url = await this.getGraphUrlByID() + `/versions/${version}/restoreversion`;
            await this.httpCall(url);
        } catch (e) {
            ret = false;
        }
        return ret;
    }



    async openDocumentAsPDF(): Promise<void> {
        var url: string = "";
        if (this.ext === "pdf") {
            url = await this.getDownloadUrl();
        } else {
            var myBlob: Blob = (await this.getContent("Blob", "pdf")) as Blob;
            url = window.URL.createObjectURL(myBlob);
        }
        window.open(url, "_blank");
    }

    async updateContent(content: Blob | ArrayBuffer | string): Promise<void> {
        try {
            var maxSize = 5 * 1024 * 1024;
            if (true) {//content["byteLength"] >= maxSize || content["size"] > maxSize || content["length"] > maxSize){
                await this.updateContentLargeFile(content);

                /*if (this.fileSystem.config.sharePointDrive > ""){
                    var myPath = this.buildSubPath();
                    url = `${this.fileSystem.config.sharePointDrive}/_api/web/GetFileByServerRelativeUrl('/${encodeURIComponent(myPath)}')/$value`;
                } else {
                    throw "Document size is too big"
                }*/
            } else {
                await this.updateContentSmallFile(content);
            }
            await this.checkFileIn();
        } catch (e) {
            throw e;
        }
    }

    async checkFileIn(): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var url = initialUrl + `/checkin`;
        try {
            var content = {
                "comment": "Regenerating form RW"
            }
            await this.httpCall(url, "POST", JSON.stringify(content));
        } catch (e) {
            console.log(`checkin fail ${url}`)
        }
    }


    private async createUploadSession(url): Promise<largeFileUpload.LargeFileUploadSession> {
        var uploadURL = url + "/createUploadSession";
        var content = {
            "@microsoft.graph.conflictBehavior": "replace",
            "fileSystemInfo": { "@odata.type": "microsoft.graph.fileSystemInfo" }
        };
        try {
            var session = await this.httpCall(uploadURL, "POST", JSON.stringify(content), "application/json")
        } catch (e) {
            throw "Error Creating Upload Session" + (e.description > "") ? e.description : e;
        }
        const largeFileUploadSession: largeFileUpload.LargeFileUploadSession = {
            url: session.uploadUrl,
            expiry: new Date(session.expirationDateTime),
        };
        return largeFileUploadSession;
    }

    private async updateContentLargeFile(content: Blob | ArrayBuffer | string): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var contentType = this.contentType;
        var options: BlobPropertyBag = {}
        if (contentType > "") options.type = contentType;
        var myBlob: Blob = new Blob([content], options);
        var largeFileUploadSession = await this.createUploadSession(initialUrl);
        await largeFileUpload.uploadLargeFile(largeFileUploadSession, myBlob, this.name);
    }

    private async updateContentSmallFile(content: Blob | ArrayBuffer | string): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var url = initialUrl + `/content`;
        var settings: any = {};
        if (content && content["type"]) { // Blob
            settings.headers = {
                "Content-Type": content["type"]
            }
            settings.processData = false;
        }
        else if (content["byteLength"] > 0) {   // ArrayBuffer
            settings.processData = false;
            settings.ContentLength = content["byteLength"];
        } else { // string
            settings.headers = {
                "Content-Type": "text/plain"
            }
        }
        await this.httpCall(url, "PUT", content, settings);
    }

    async openDocument(readMode: boolean = true, desktopWord: boolean = false): Promise<void> {
        let url: string = "";
        if (desktopWord) {
            var path = await this.buildSubPath();
            var downloadURL = await this.getDownloadUrl();
            var siteName = downloadURL.substring(0, downloadURL.indexOf("/_layou"));
            url = `${siteName}/Documents/${path}`;
            try {
                var root = this.fileSystem.config.host;
                root = root.replace("/drive", "/lists");
                var response = await this.httpCall(root);
                var val = response.value;
                var notFound = true;
                for (var counter = 0; counter < val.length; counter++) {
                    if (val[counter].name === "Documents") {
                        notFound = false;
                    }
                }
                if (notFound) {
                    url = `${siteName}/Shared Documents/${path}`;
                }
            } catch (e) {
                console.log("crash")
                console.log(e)
            }
            url = `ms-word:ofe|u|` + url;
        } else {
            url = await this.getDownloadUrl();
            if (readMode) {
                url = url.replace("&action=default", "&action=view");
            }

        }
        window.open(url);
    }
}


function fillNewEntryProporties(newEntry: FileEntry | FolderEntry, currentPath: string, data: any): FileEntry | FolderEntry {
    newEntry.fullPath = currentPath;
    newEntry.id = data.id;
    if (data.lastModifiedDateTime) newEntry.modifiedDate = data.lastModifiedDateTime;
    if (data.createdDateTime) newEntry.createdDate = data.createdDateTime;
    if (data.size) newEntry.size = data.size;
    if (data.createdBy && data.createdBy.user) newEntry.createdBy = data.createdBy.user.displayName;
    return newEntry;
}

export class FolderEntry extends BaseEntry implements fb.FolderEntry {
    isFile: boolean = false;
    isDirectory: boolean = true;

    // may support wild card filespec 
    async getContentList(filespec?: string): Promise<Array<FileEntry | FolderEntry>> {
        var myContent: Array<FileEntry | FolderEntry> = [];
        var currentPath = this.buildSubPath();
        var url = `${this.fileSystem.config.host}/root:`;
        if (this.fileSystem.config.fileUrl > "")
            url += `('${this.fileSystem.config.fileUrl}${currentPath}')`;
        else
            url += "/" + currentPath;

        url += ":/children";

        try {
            var data = await this.httpCall(url);
            var folders = data.value
            for (var i = 0; i < folders.length; i++) {
                var theName = folders[i].name;
                var newEntry: any = null;
                if (folders[i].folder) {
                    newEntry = new FolderEntry(theName, this.fileSystem);
                } else {
                    newEntry = new FileEntry(theName, this.fileSystem);
                }
                if (newEntry) {
                    newEntry = fillNewEntryProporties(newEntry, currentPath, folders[i] as any);
                    myContent.push(newEntry);
                }
            }
            /*var files = data['d'].Files.results
            for (var i = 0; i < files.length; i++) {
                var newFile: FileEntry = new FileEntry(folders[i].Name, this.fileSystem);
                newFile.fullPath = currentPath;
                myContent.push(newFile);
            }*/
        } catch (e) {
            throw "Error getting folder content " + e;
        }

        return myContent;
    }


    // name can be under sub directory like  '456/uploaded/driverlic.png'
    // there is not no reason not support absulate path as well like '/client files/2019/02/M43458/inital letter.docx' 
    // but logiclly not good idea, it make the code not easy to read
    // create if do not exist when pass {create:true} option, it should be able to create sub directory as well
    async getFolder(name: string, options?: FileSystemOptions): Promise<FolderEntry> {
        if (!(name > "")) throw "Folder name not specified";
        var myFolder: FolderEntry = null;
        //var url = `${this.fileSystem.config.rootUrl}('${this.fileSystem.config.fileUrl}${this.buildCurrentPath()}/${name}')`;
        var url = `${this.buildFullPath()}/${name}`;
        var subFolderPath = name.lastIndexOf('/') === -1 ? "" : name.substring(0, name.lastIndexOf('/'));
        try {
            var data = await this.httpCall(url);
            myFolder = new FolderEntry(data.name, this.fileSystem);
            var currentPath = this.buildSubPath();
            if (subFolderPath > "") currentPath += "/" + subFolderPath;
            myFolder = fillNewEntryProporties(myFolder, currentPath, data as any) as FolderEntry;
        } catch (e) {
            if (options && options.create) {
                try {
                    var actualName = name;
                    var fullPath = `${this.buildFullPath()}`;
                    url = fullPath;
                    if (subFolderPath) {
                        await this.fileSystem.root.getFolder(subFolderPath, options);
                        // why need delay   await delay(5000)
                        actualName = actualName.substring(actualName.lastIndexOf('/') + 1);
                        url += `/${subFolderPath}`;
                    }
                    url += `:/children`;
                    var myPost = {
                        "name": actualName,
                        "folder": {}
                    }
                    try {
                        try {
                            await this.httpCall(url, "POST", JSON.stringify(myPost));
                        } catch (e) {
                            var myPost2 = {
                                "name": this.name,
                                "folder": {}
                            }
                            var sub = fullPath.substring(0, fullPath.lastIndexOf("/"));
                            var subUrl = sub + `:/children`;
                            if (sub.lastIndexOf(":") === (sub.length - 1)) { // if at root
                                subUrl = sub.substring(0, sub.length - 1) + "/children";
                            }
                            await this.httpCall(subUrl, "POST", JSON.stringify(myPost2));
                            //    await delay(5000)
                            await this.httpCall(url, "POST", JSON.stringify(myPost));
                        }
                        //await fsoMakeTheCall(url, "POST", `{"name": "${actualName}","folder": { }}`);
                        // await delay(5000);
                        myFolder = await this.fileSystem.root.getFolder(name);
                    } catch (e) {

                    }
                } catch (e) {
                    throw `Can't create folder '${name}': ${e}`;
                }
            } else {
                throw `Can't retrieve folder '${name}': ${e}`;
            }
        }

        return myFolder;
    }

    async getFileByID(id: string): Promise<FileEntry> {
        if (!(id > "")) throw "File id not specified";
        var myFile: FileEntry = null;
        try {
            var url = `${this.fileSystem.config.host}/items/${id}`;
            var data = await this.httpCall(url);
            var currentPath = this.buildSubPath();
            myFile = new FileEntry(data.name, this.fileSystem);
            var fileLoc = data.parentReference.path;
            var newPath = fileLoc.substring(fileLoc.indexOf(currentPath) + currentPath.length);
            myFile.fullPath = currentPath + newPath;
        } catch (e) {
            throw `Can't retrieve file '${id}': ${e}`
        }
        return myFile;
    }
    async getFile(name: string, options?: FileSystemOptions, fileContent?: | Blob | ArrayBuffer): Promise<FileEntry> {
        if (!(name > "")) throw "File name not specified";
        let myFile: FileEntry = null;
        let url = `${this.buildFullPath()}/${name}`;
        let subFolderPath = name.lastIndexOf('/') === -1 ? "" : name.substring(0, name.lastIndexOf('/'));
        let currentPath = this.buildSubPath();
        if (subFolderPath > "") currentPath += "/" + subFolderPath;
        try {
            let data = await this.httpCall(url);
            myFile = new FileEntry(data.name, this.fileSystem);
            myFile = fillNewEntryProporties(myFile, currentPath, data as any) as FileEntry;
            // console.log(this);
            if (options && options.overwrite && fileContent) {
                try {
                    await myFile.updateContent(fileContent);
                } catch (e) {
                    throw "ldd_found_butFailedUpdate" + e;
                }
            }
        } catch (e) {
            if (e.indexOf("ldd_found_butFailedUpdate") == 0) {
                throw e.replace("ldd_found_butFailedUpdate", "");
            }
            else if (options && options.create && fileContent) {
                try {
                    let pFolder: FolderEntry = this;
                    let actualName = name;
                    if (subFolderPath > "") {
                        pFolder = await this.getFolder(subFolderPath, { create: true });
                        actualName = actualName.substring(actualName.lastIndexOf('/') + 1);
                        //    await delay(5000)
                    }
                    let url2 = await pFolder.getGraphUrlByID() + `/children`;
                    let myPost = {
                        "name": actualName,
                        "file": {}
                    };
                    let data2 = await this.httpCall(url2, "POST", JSON.stringify(myPost));
                    myFile = new FileEntry(data2.name, this.fileSystem);
                    myFile = fillNewEntryProporties(myFile, currentPath, data2 as any) as FileEntry;
                    try {
                        //   await delay(9000)
                        await myFile.updateContent(fileContent);
                    } catch (e) {
                        try {
                            await myFile.remove();
                        } catch (e) {
                        }
                        throw "can't update file" + e;
                    }
                } catch (e) {
                    throw `Can't create file '${name}': ${e}`;
                }
            } else {
                throw `Can't retrieve file '${name}': ${e}`
            }
        }
        return myFile;
    }
}

export class FileSystem extends fb.FileSystem {
    config: SPFileSystemConfig;
    root: FolderEntry;
    constructor(config: SPFileSystemConfig) {
        super(config); // doesn't seem to set in this env
        this.config = config;
        //console.log('file system '+ this.config)
        this.root = new FolderEntry(config.rootDrive, this);
    }

    async getAccessToken(): Promise<string> {
        return "ldd_fake_drive_token"
    }
}